import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from "../../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../../core/shared/widget/service/widget.factory";

@Component({
    selector: 'bm-creditor-basic-data-component',
    templateUrl: 'creditor-basic-data.component.html',
    standalone: false
})
export class CreditorBasicDataComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    @Input() creditorId: number;

    creditorBasicDataWidgetData: WidgetData;

    constructor() {
    }

    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {

        this.creditorBasicDataWidgetData = WidgetFactory.createWidgetEntityData(
            'bm.creditor.basic.data.widget.data',
            'Creditor Basic Details',
            'bm.Creditor',
            this.creditorId
        );

        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
